module.exports = __webpack_public_path__ + "img/img20.710cd155.svg";